/* @flow */
import cx from 'classnames';
import ChatMessage from 'entities/ChatMessage';
import MessageReaction from 'chat/components/MessageReaction.jsx';
import React from 'react';
import Reaction from 'entities/Reaction';
import ReactionButton from 'chat/components/ReactionButton.jsx';
import ReactionSummary from 'entities/ReactionSummary';

import './styles/ReactionDisplay.scss';

type Props = {
  message: ChatMessage,
  reactionSummary: ?ReactionSummary,
  sentBySelf?: boolean,
}

class ReactionDisplay extends React.Component {
  props: Props;

  renderReaction = (reaction: Reaction) => {
    return (
      <MessageReaction
        message={this.props.message}
        key={reaction.getName()}
        reaction={reaction}
      />
    );
  };

  render() {
    const { message, reactionSummary, sentBySelf } = this.props;
    const reactions = reactionSummary ? reactionSummary.getReactions() : null;

    if (!reactions || reactions.isEmpty()) {
      return null;
    }

    return (
      <div
        className={cx('ReactionDisplay', {
          'ReactionDisplay-self': sentBySelf,
          'ReactionDisplay-other': !sentBySelf,
        })}>
        {reactions.map(this.renderReaction)}
        <ReactionButton
          className="ReactionDisplay-addButton"
          message={message}
        />
      </div>
    );
  }
}

export default ReactionDisplay;



// WEBPACK FOOTER //
// ./src/chat/components/ReactionDisplay.jsx